import { render, staticRenderFns } from "./asideMenuLayout.vue?vue&type=template&id=50d5ebc2&scoped=true"
import script from "./asideMenuLayout.vue?vue&type=script&lang=js"
export * from "./asideMenuLayout.vue?vue&type=script&lang=js"
import style0 from "./asideMenuLayout.vue?vue&type=style&index=0&id=50d5ebc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5ebc2",
  null
  
)

export default component.exports